import outcess1 from "../assets/img/outcess-photo/outcess1.jpeg";
import outcess2 from "../assets/img/outcess-photo/outcess2.jpeg";
import outcess3 from "../assets/img/outcess-photo/outcess3.jpeg";
import outcess4 from "../assets/img/outcess-photo/outcess4.jpeg";
import outcess5 from "../assets/img/outcess-photo/outcess5.jpeg";
import outcess6 from "../assets/img/outcess-photo/outcess6.jpeg";
import outcess7 from "../assets/img/outcess-photo/outcess7.jpeg";
import outcess8 from "../assets/img/outcess-photo/outcess8.jpeg";
import outcess9 from "../assets/img/outcess-photo/outcess9.jpeg";
import outcess10 from "../assets/img/outcess-photo/outcess10.jpeg";
import outcess11 from "../assets/img/outcess-photo/outcess11.jpeg";
import outcess12 from "../assets/img/outcess-photo/outcess12.jpeg";
import outcess13 from "../assets/img/outcess-photo/outcess13.jpeg";
import outcess14 from "../assets/img/outcess-photo/outcess14.jpeg";
import outcess15 from "../assets/img/outcess-photo/outcess15.jpg";
import outcess16 from "../assets/img/outcess-photo/outcess16.jpeg";
import outcess17 from "../assets/img/outcess-photo/outcess17.jpeg";
import outcess18 from "../assets/img/outcess-photo/outcess18.jpeg";
import outcess19 from "../assets/img/outcess-photo/outcess19.jpeg";
import outcess20 from "../assets/img/outcess-photo/Abuja1.jpg";
import outcess21 from "../assets/img/outcess-photo/Abuja2.jpg";
import outcess22 from "../assets/img/outcess-photo/Abuja3.jpg";
import outcess23 from "../assets/img/outcess-photo/Abuja4.jpg";
import outcess24 from "../assets/img/outcess-photo/Abuja5.jpg";
import outcess25 from "../assets/img/outcess-photo/outcess21.jpeg";


export const IMAGES = [
  {
    src: outcess1,
    width: 1080,
    height: 715,
    category: "Operations",
    title: "Operations Excellence",
  },
  {
    src: outcess2,
    width: 1080,
    height: 715,
    category: "Operations",
    title: "Business Support",
  },
  {
    src: outcess3,
    width: 1080,
    height: 720,
    category: "Team",
    title: "Outcess Team",
  },
  {
    src: outcess4,
    width: 1080,
    height: 720,
    category: "Team",
    title: "Collaboration Session",
  },
  {
    src: outcess5,
    width: 1080,
    height: 720,
    category: "Events",
    title: "Corporate Event",
  },
  {
    src: outcess6,
    width: 1080,
    height: 720,
    category: "Events",
    title: "Industry Engagement",
  },
  {
    src: outcess7,
    width: 1080,
    height: 720,
    category: "Clients",
    title: "Client Partnership",
  },
  {
    src: outcess8,
    width: 1080,
    height: 720,
    category: "Clients",
    title: "Business Meeting",
  },
  {
    src: outcess9,
    width: 1080,
    height: 720,
    category: "Operations",
    title: "Customer Support",
  },
  {
    src: outcess10,
    width: 1080,
    height: 720,
    category: "Operations",
    title: "Service Delivery",
  },
  {
    src: outcess11,
    width: 1080,
    height: 720,
    category: "Team",
    title: "Workplace Culture",
  },
  {
    src: outcess12,
    width: 1080,
    height: 720,
    category: "Team",
    title: "Professional Development",
  },
  {
    src: outcess13,
    width: 1080,
    height: 720,
    category: "Events",
    title: "Conference Participation",
  },
  {
    src: outcess14,
    width: 1080,
    height: 720,
    category: "Events",
    title: "Networking Session",
  },
  {
    src: outcess15,
    width: 570,
    height: 380,
    category: "Clients",
    title: "Client Success",
  },
  {
    src: outcess16,
    width: 1080,
    height: 720,
    category: "Clients",
    title: "Business Growth",
  },
  {
    src: outcess17,
    width: 1080,
    height: 715,
    category: "Operations",
    title: "Operational Excellence",
  },
  {
    src: outcess18,
    width: 1080,
    height: 715,
    category: "Operations",
    title: "Process Management",
  },
  {
    src: outcess19,
    width: 1080,
    height: 715,
    category: "Team",
    title: "Employee Engagement",
  },
  {
    src: outcess20,
    width: 960,
    height: 1280,
    category: "Events",
    title: "Abuja Event",
  },
  {
    src: outcess21,
    width: 960,
    height: 1280,
    category: "Events",
    title: "Abuja Conference",
  },
  {
    src: outcess22,
    width: 1280,
    height: 960,
    category: "Events",
    title: "Industry Summit",
  },
  {
    src: outcess23,
    width: 1280,
    height: 960,
    category: "Events",
    title: "Professional Gathering",
  },
  {
    src: outcess24,
    width: 250,
    height: 333,
    category: "Events",
    title: "Business Forum",
  },
  {
    src: outcess25,
    width: 1024,
    height: 768,
    category: "Clients",
    title: "Customer Experience",
  },
];
